import { ActiveModel, ActiveField } from '@alt-point/active-models/src'

/**
* Class OrderPayRequestV1
*  Данные для оплаты заказа (ApiVersion 1)
*/
export class OrderPayRequestV1 extends ActiveModel {

/**
  * paymentMethod
  * Код метода оплаты («Card», «Dolyami»); если не передан — «Card»<br>
  */
  @ActiveField()
  paymentMethod?: null | string


/**
  * successUrl
  * URL на веб-сайте мерчанта, куда будет переведен покупатель в случае успешной оплаты<br>
  */
  @ActiveField()
  successUrl?: null | string


/**
  * failUrl
  * URL на веб-сайте мерчанта, куда будет переведен покупатель в случае неуспешной оплаты<br>
  */
  @ActiveField()
  failUrl?: null | string
}
